// removed by extract-text-webpack-plugin
module.exports = {"column":"c-Column__column","small":"c-Column__small"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/Column/Column.scss
// module id = 792
// module chunks = 0